import styles from './PrivacyPage.module.css'

/**
 * Страница /privacy — политика конфиденциальности (заглушка).
 */
export const PrivacyPage = () => (
  <article className={styles.article}>
    <h1 className={styles.title}>Политика конфиденциальности</h1>
    <p className={styles.text}>Текст политики конфиденциальности будет размещён здесь.</p>
  </article>
)

export default PrivacyPage
